export default {"src":"/_next/static/media/empty-card-full.4fe7ee33.svg","height":253,"width":555};